import { FormattedMessage } from "react-intl";

import AccountCreation from "@/components/signup/account-creation";
import { SignupBackgroundLayout } from "@/components/signup/layouts";
import { ServiceCollectionLogo } from "@/components/signup/utils";

import { GetStartedHeading, SubHeading } from "../components";

export const LoggedOut = () => (
    <SignupBackgroundLayout
        ProductLogo={<ServiceCollectionLogo />}
        theme="yellow"
    >
        <GetStartedHeading productName="Service Collection" />
        <SubHeading>
            <FormattedMessage
                id="signup.serviceCollection.subHeading"
                defaultMessage="It’s free for up to 3 agents - no credit card needed."
            />
        </SubHeading>
        <AccountCreation />
    </SignupBackgroundLayout>
);
